import React, { useEffect } from "react";
import styles from "./VideoZoom.module.scss";

interface VideoZoomProps {
  src: string;
  title?: string;
  onClose: () => void;
}

const VideoZoom: React.FC<VideoZoomProps> = ({
  src,
  title = "Video",
  onClose,
}) => {
  useEffect(() => {
    // ESC tuşu ile kapatma
    const handleEsc = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    window.addEventListener("keydown", handleEsc);

    // Body scroll'u engelle
    document.body.style.overflow = "hidden";

    return () => {
      window.removeEventListener("keydown", handleEsc);
      document.body.style.overflow = "auto";
    };
  }, [onClose]);

  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className={styles.backdrop} onClick={handleBackdropClick}>
      <div className={styles.videoContainer}>
        <iframe
          src={src}
          title={title}
          className={styles.video}
          onClick={(e) => e.stopPropagation()}
          allowFullScreen
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        />
      </div>
    </div>
  );
};

export default VideoZoom;
